<!--
 * @Description: 上工详情组件
 * @Author: sunhuihong
 * @Date: 2025-11-07 12:43:52
-->
<template>
  <el-dialog width="1070px" center title="上工详情" :visible.sync="visible" :close-on-click-modal="false"
    @open="initData" :before-close="handleCancel">
    <div class="duty-details-body">
      <div class="duty-details-header">
        <el-descriptions title="" :column="24" direction="vertical">
          <el-descriptions-item :span="4" label="姓名">
            {{dutyReportDo.name || '- -'}}
            <span v-if="dutyReportDo.mobile">{{dutyReportDo.mobile}}</span>
          </el-descriptions-item>
          <el-descriptions-item :span="4" label="身份证号">
            {{dutyReportDo.idNo || '- -'}}
          </el-descriptions-item>
          <el-descriptions-item :span="4" label="当前状态">
            {{dutyReportDo.statusText || '- -'}}
          </el-descriptions-item>
          <el-descriptions-item :span="4" label="总空闲 (天)">
            {{dutyReportDo.totalIdleDays || '- -'}}
          </el-descriptions-item>
          <el-descriptions-item :span="4" label="最长连续空闲 (天)">
            {{dutyReportDo.maxIdleDays || '- -'}}
          </el-descriptions-item>
          <el-descriptions-item :span="4" label="最长连续上工 (天)">
            {{dutyReportDo.maxDutyDays || '- -'}}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <el-row class="duty-details-search" :gutter="0" type="flex" justify="space-between" align="middle">
        <el-col :span="24" style="text-align: left">
          <el-date-picker v-model="dateRange" style="width: 260px" type="daterange" prefix-icon="el-icon-date"
            align="right" unlink-panels range-separator="至" start-placeholder="开始日期" :clearable="false"
            end-placeholder="结束日期" :picker-options="dateRangePickerOptions" size="small"
            @change="datePickerChange" @blur="datePickerBlur">
          </el-date-picker>
        </el-col>
      </el-row>
      <el-table :data="dataTable" max-height="310" border class="duty-table">
        <el-table-column v-for="day in weekDays" :key="day.key" :label="day.label" min-width="15%">
          <template slot-scope="{ row }">
            <div class="duty-day">{{ getDate(row[day.key]) }}</div>
            <div :class="getStatusClass(row[day.key], day.key, row)">
              {{ getStatus(row[day.key]) }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="dialog-footer">
        <el-button @click="handleCancel">关 闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Util from "@/global/Util.js";
import Constant from "@/global/Constant.js";
export default {
  name: 'DutyDetails',
  props: ["visible", "filterParams"],

  data() {
    return {
      dutyReportDo: {},
      dataTable: [], //表格数据
      dateRange: null, //日期范围
      dateRangePickerOptions: {
				disabledDate: this.disabledDate,
        onPick: this.datePick,
        shortcuts: this.dateUtil.dateRangePickerOptions.shortcuts
			},
      pickDate: null,
      weekDays: [
        {key: 'MONDAY', label: '周一'},
        {key: 'TUESDAY', label: '周二'},
        {key: 'WEDNESDAY', label: '周三'},
        {key: 'THURSDAY', label: '周四'},
        {key: 'FRIDAY', label: '周五'},
        {key: 'SATURDAY', label: '周六'},
        {key: 'SUNDAY', label: '周日'}
      ],
    }
  },

  methods: {
    initData() {
      this.dateRange = [this.filterParams.startDate, this.filterParams.endDate];
      this.getAtdnDutyDetails();
    },

    getAtdnDutyDetails() {
      let params = {
        startDate: this.dateRange && this.dateRange.length ? this.dateUtil.dateFormat(this.dateRange[0], 'YYYY-MM-DD') : '',
        endDate: this.dateRange && this.dateRange.length ? this.dateUtil.dateFormat(this.dateRange[1], 'YYYY-MM-DD') : '',
        atdnId: this.filterParams.atdnId
      }
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_ATDN_DUTY_DETAILS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.dutyReportDo = result.data.dutyReportDto;
        let statusList = this.rebuiltStatusList(result.data.statusList);
        this.dataTable = this.processDtuyData(statusList);
      });
    },

    rebuiltStatusList(list) {
      return list.map(item => ({
        date: item[0],
        day: item[1],
        status: Number(item[2]),
        statusText: item[3]
      }));
    },

    /**
    * 处理排班数据，将平铺的数据按周分组
    * @param {Array} data - 原始排班数据数组
    * @return {Array} 按周分组后的表格数据
    */
    processDtuyData(data) {
      if (!data.length) return [];
      let result = [];
      let currentWeek = this.createEmptyWeek();
      data.forEach(item => {
        if (item.day === 'MONDAY' && this.hasWeekData(currentWeek)) {
          result.push(currentWeek);
          currentWeek = this.createEmptyWeek();
        }
        currentWeek[item.day] = `${item.date}|${item.statusText}`;
      })
      if (this.hasWeekData(currentWeek)) {
        result.push(currentWeek);
      }
      return this.markContinuousStatus(result);
    },

    //创建空的周数据对象,返回包含星期字段和连续状态标识的空对象
    createEmptyWeek() {
      let week = {MONDAY: '', TUESDAY: '', WEDNESDAY: '', THURSDAY: '', FRIDAY: '', SATURDAY: '', SUNDAY: ''};
      week.continuousStatus = {};
      this.weekDays.forEach(day => {
        week.continuousStatus[day.key] = {isContinuous: false, isStart: false, isEnd: false};
      })
      return week;
    },

    /**
    * 检查周对象是否包含数据
    * @param {Object} week - 周数据对象
    * @return {Boolean} 是否包含数据
    */
    hasWeekData(week) {
      return this.weekDays.some(day => week[day.key]);
    },

    /**
    * 标记连续排班状态, 识别连续的上工或空闲状态，并标记开始和结束位置
    * @param {Array} weeks - 周数据数组
    * @return {Array} 标记了连续状态的周数据
    */
    markContinuousStatus(weeks) {
      // 重置所有连续状态
      weeks.forEach(week => {
        this.weekDays.forEach(day => {
          week.continuousStatus[day.key] = {isContinuous: false, isStart: false, isEnd: false};
        });
      });
      let allDays = []; // 存储所有日期的数组
      // 将周数据处理为连续的日期数组
      weeks.forEach(week => {
        this.weekDays.forEach(day => {
          if (week[day.key]) {
            allDays.push({week: week, day: day.key, status: this.getStatus(week[day.key]), date: this.getDate(week[day.key])});
          }
        });
      });
      // 遍历所有日期，标记连续状态
      let currentStreak = [];
      let prevStatus = null;
      allDays.forEach((dayInfo, _index) => {
        const currentStatus = dayInfo.status;
        // 检查是否与前一天状态相同且为有效状态
        if (currentStatus === prevStatus && ['上工', '空闲'].includes(currentStatus)) {
          currentStreak.push(dayInfo);
        } else {
          // 处理前一个连续段
          if (currentStreak.length > 1) {
            this.markStreakBoundaries(currentStreak);
          }
          // 开始新的连续段
          currentStreak = ['上工', '空闲'].includes(currentStatus) ? [dayInfo] : [];
        }  
        prevStatus = currentStatus;
      });
      // 处理最后一个连续段
      if (currentStreak.length > 1) {
        this.markStreakBoundaries(currentStreak);
      }
      return weeks;
    },

    /**
    * 标记连续段的开始和结束位置
    * @param {Array} streak - 连续段的日期信息数组
    */
    markStreakBoundaries(streak) {
      streak.forEach((dayInfo, index) => {
        dayInfo.week.continuousStatus[dayInfo.day].isContinuous = true;
        // 标记开始位置（第一个）
        if (index === 0) {
          dayInfo.week.continuousStatus[dayInfo.day].isStart = true;
        }
        // 标记结束位置（最后一个）
        if (index === streak.length - 1) {
          dayInfo.week.continuousStatus[dayInfo.day].isEnd = true;
        }
      });
    },

    /**
    * 获取状态单元格的CSS类名
    * 根据排班状态和连续状态动态生成对应的样式类
    * @param {String} cellData - 单元格数据（日期|状态）
    * @param {String} day - 星期字段名
    * @param {Object} row - 当前行数据
    * @return {String} CSS类名字符串
    */
    getStatusClass(cellData, day, row) {
      if (!cellData) return 'duty-default-status';
      
      let status = this.getStatus(cellData);
      let continuousInfo = row.continuousStatus[day];
      
      let baseClass = (status === '空闲' && continuousInfo.isContinuous) ? 'duty-status-free' : 
                      (status === '上工' && continuousInfo.isContinuous) ? 'duty-status-start-work' : 
                      (status === '空闲' && !continuousInfo.isContinuous) ? 'default-duty-status-free' :
                      (status === '上工' && !continuousInfo.isContinuous) ? 'default-duty-status-start-work' : 
                      'duty-default-status';
      let classes = [baseClass];
      // 只有在连续段的开始位置才显示左边框
      if (continuousInfo.isContinuous && continuousInfo.isStart) {
        classes.push('duty-continuous-start');
      }
      return classes.join(' ');
    },

    //获取日期部分
    getDate(str) {
      return str ? str.split("|")[0] : ''
    },
    
    //获取状态部分
    getStatus(str) {
      return str ? str.split("|")[1] : ''
    },

    datePickerChange() {
      this.getAtdnDutyDetails();
    },

    datePickerBlur() {
      this.pickDate = null;
    },

    disabledDate(date) {
      return Util.disabledDateByOneYear(date, this.pickDate);
    },

    datePick(pick) {
      this.pickDate = pick;
    },

    //关闭弹框
    handleCancel() {
      this.$emit("close-dialog")
    }
  }
}
</script>

<style scoped>
.duty-details-body {
  padding: 5px 25px;
}

.duty-details-header {
  background: #EFF5FF;
  padding: 20px;
}

.duty-details-search {
  margin: 20px 0;
  text-align: left;
}

.duty-day {
  padding: 10px 0;
  color: #333;
}

.duty-default-status {
  border-top: 1px solid #EBEEF5;
  padding: 10px 0;
  color: #333333;
}

.default-duty-status-free {
  border-top: 1px solid #EBEEF5;
  padding: 10px 0;
  color: #FE9100;
}

.default-duty-status-start-work {
  border-top: 1px solid #EBEEF5;
  padding: 10px 0;
  color: #3E7EF5;
}

.duty-status-free {
  border-top: 1px solid #EBEEF5;
  padding: 10px 0;
  color: #FE9100;
  background: #FFECD0;
}

.duty-status-start-work {
  border-top: 1px solid #EBEEF5;
  padding: 10px 0;
  color: #3E7EF5;
  background: #E0EAFC;
}

.duty-continuous-start.duty-status-free {
  border-left: 3px solid #FFA500;
}

.duty-continuous-start.duty-status-start-work {
  border-left: 3px solid #3E7EF5;
}

.dialog-footer {
  text-align: center;
  margin-top: 20px;
}
</style>

<style>
.duty-details-body .duty-details-header .el-descriptions__body {
  background: #EFF5FF;
}

.duty-details-body .duty-details-header .el-descriptions-item__label {
  background: #EFF5FF;
  font-weight: 600;
  color: #92969b;
}

.duty-details-body .duty-details-header .el-descriptions-item__content {
  color: #000;
  font-weight: 600;
}

.duty-table .el-table__cell {
  padding: 0 !important;
}

.duty-table th .cell {
  text-align: center !important;
  padding: 10px 0 !important;
  background: #F5F6FA;
}

.duty-table td .cell {
  text-align: center !important;
  padding: 0 !important;
}

.duty-table .el-table__body tr.hover-row > td,
.duty-table .el-table__body tr:hover > td {
  background: transparent !important; 
}
</style>


// WEBPACK FOOTER //
// src/components/report/components/DutyDetails.vue